module.exports = __webpack_public_path__ + "static/TryHackMe-e49ecf40c7fdf87b783f5d2b575fe517.png";